module.exports = __webpack_public_path__ + "static/img/manual_ja_6.93ac31c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_6.png
// module id = IPxL
// module chunks = 4